/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RmaItemDto } from './rmaItemDto';
import { AdminOrderComment } from './adminOrderComment';
import { RmaAttachmentGetDto } from './rmaAttachmentGetDto';


export interface AdminRma { 
    id: string;
    insertionTimestamp: string;
    assignedUserId?: number;
    createdByIsAdmin?: boolean;
    createdByUserId?: number;
    formattedRmaNumber: string;
    rmaNumber?: number;
    customerName: string;
    customerOrganization: string;
    additionalEmailAddress?: string;
    comment?: string;
    adminComments?: Array<AdminOrderComment>;
    packageReceivedDeTimestamp?: string;
    packageReceivedUsTimestamp?: string;
    packageSentFromUsToDeTimestamp?: string;
    rmaCompletedTimestamp?: string;
    dataAvailableNotificationSentAt?: string;
    quoteBeforeShipping?: boolean;
    numberOfOtherDevices?: number;
    rmaStatus: AdminRma.RmaStatusEnum;
    assignedSalesUserId?: number;
    attachments?: Array<RmaAttachmentGetDto>;
    fakturaId?: string;
    rmaTicket?: string;
    items: Array<RmaItemDto>;
}
export namespace AdminRma {
    export const RmaStatusEnum = {
        Created: 'Created',
        PackageReceivedInUs: 'PackageReceivedInUs',
        PackageSentFromUsToDe: 'PackageSentFromUsToDe',
        PackageReceivedInDe: 'PackageReceivedInDe',
        DeviceInspection: 'DeviceInspection',
        Quotation: 'Quotation',
        InConfiguration: 'InConfiguration',
        InRefurbishment: 'InRefurbishment',
        Completed: 'Completed'
    } as const;
    export type RmaStatusEnum = typeof RmaStatusEnum[keyof typeof RmaStatusEnum];
}


export type RmaStatusEnum = typeof AdminRma.RmaStatusEnum[keyof typeof AdminRma.RmaStatusEnum];
